import { combineReducers } from "@reduxjs/toolkit";
import transactionReducer from "./transaction";
import transactionRefundReducer from "./transactionRefund";

const merchantReducer = combineReducers({
    transaction: transactionReducer,
    refund: transactionRefundReducer,
})

export default merchantReducer